import { Component, input, output, ViewChild } from '@angular/core';

import { ISessionEntry } from './IRaceTiming';
import { TimingTowerConfigurableComponent } from './timing-tower-configurable/timing-tower-configurable.component';
import { TIMING_TOWER_COMPACT_CONFIG } from './timing-tower-configurable/timing-tower-column-config';

/**
 * Compact timing tower component - delegates to the configurable component.
 * This component is maintained for backward compatibility.
 */
@Component({
	selector: 'vb-lxp-timing-tower',
	imports: [TimingTowerConfigurableComponent],
	templateUrl: './timing-tower.component.html',
	styleUrl: './timing-tower.component.css',
})
export class TimingTowerComponent {
	@ViewChild(TimingTowerConfigurableComponent)
	configurableComponent: TimingTowerConfigurableComponent;

	public config = TIMING_TOWER_COMPACT_CONFIG;
	public enableColumnCustomization = input(false);
	public hideColumnSelection = input(false);
	public enableMoreColumns = input(false);
	public activeClass = input('');
	public activeNumberClass = input('');
	public selectedClasses = input<string[]>([]);

	public selectionAdded = output<ISessionEntry>();
	public selectionRemoved = output<ISessionEntry>();

	public openColumnSettings(): void {
		this.configurableComponent?.openColumnSettings();
	}
}
